import { ComposeView } from "../compose/ComposeView";

export function ComposeTab() {
  return <ComposeView />;
}
